
<div class="cp-material">
  <Close is-mobile @close="handleClose" class="close"></Close>
</div>
